import { combineReducers } from 'redux';

import organization from './layout-page/reducers';
import comment from './reducers/comment-reducer';
import auth from './reducers/auth-reducer';
import publication from './about-page/reducers';
import speakers from './speakers-page/reducers';
import participant from './reducers/participant-reducer';
import participants from './participants-page/reducers';
import schedule from './schedule-page/reducers';
import fields from './reducers/field-reducer';
import googleFormReducer from './reducers/google-form-reducer';

export default combineReducers({
  organization, comment, publication,
  auth, speakers, participant, participants,
  schedule, fields, googleFormReducer
});



// WEBPACK FOOTER //
// ./src/root-reducer.js